<template>
  <div id="slate-int-calculator-chart-header" :style="{ width: chartWidth }">
    <transition-group tag="div" :class="['sentence-slider', forwardOrBack]" name="slide">
      <div v-for="number in [currentSlide]" :key="number">
        <div class="sentence" v-html="sentences[currentSlide]"></div>
      </div>
    </transition-group>
    <div class="buttons">
      <table class="button-container previous" v-show="currentSlide!==0" @click="backButtonPress">
        <tr>
          <td class="arrow">←</td>
          <td class="button">{{ prevButton }}</td>
        </tr>
      </table>
      <table class="button-container next" v-show="currentSlide!==(slideData.length - 1)" @click="forwardButtonPress" >
        <tr>
          <td class="button">{{ nextButton }}</td>
          <td class="arrow">→</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3'

export default {
  name: 'chart-header',
  computed: {
    noSex () { return this.userFreq === 0 },
    toWhat () { return this.noSex ? 'toSame' : 'toLess' },
    ageString () { return this.ageCategories[this.ageGroup] },
    freqString () { return this.noSex ? 'hadn’t had sex' : `had had sex ${this.freqCategories[this.userFreq].toLowerCase()}` },
    sentences () { return this.slideData.map((slide, i) => this.getSentence(i)) },
    prevButton () { return this.buttons[this.currentSlide] },
    nextButton () { return this.buttons[this.currentSlide + 2] }
  },
  watch: {
    currentSlide: function (newVal, oldVal) {
      this.forwardOrBack = newVal > oldVal ? 'forward' : 'back'
    }
  },
  methods: {
    getSentence (i) {
      let percentageString
      let partnerString
      switch (i) {
        case 0:
          percentageString = this.getPercentageString(i)
          partnerString = this.getPartnerString(this.hasPartner)
          if (this.toWhat === 'toSame') {
            return `Among <em>all</em> GSS respondents, ${percentageString} also said they ${this.freqString} in the last 12 months.`
          } else return `You had sex ${this.adverb} frequently than ${percentageString} of GSS respondents.`
        case 1:
          percentageString = this.getPercentageString(i)
          partnerString = this.getPartnerString(this.hasPartner)
          if (this.toWhat === 'toSame') {
            return `Among GSS respondents who ${partnerString} a regular sex partner, ${percentageString} also said they ${this.freqString} in the last 12 months.`
          } else return `You had sex ${this.adverb} frequently than ${percentageString} of the GSS respondents who ${partnerString} a regular sex partner.`
        case 2:
          percentageString = this.getPercentageString(i)
          partnerString = this.getPartnerString(this.hasPartner)
          if (this.toWhat === 'toSame') {
            return `Among GSS respondents in your age category—${this.ageString}—who ${partnerString} a regular sex partner, ${percentageString} also said they ${this.freqString} in the last 12 months.`
          } else return `You had sex ${this.adverb} frequently than ${percentageString} of the GSS respondents in your age category—${this.ageString}—who ${partnerString} a regular sex partner.`
        case 3:
          partnerString = this.getPartnerString(this.hasPartner)
          return `Here are the stats for all age categories among GSS respondents who ${partnerString} a regular sex partner.`
        case 4:
          partnerString = this.getPartnerString(1 - this.hasPartner)
          return `And here are the stats for all age categories among GSS respondents who <em>${partnerString}</em> a regular sex partner.`
      }
    },
    getPercentageString (i) {
      let percentageString = this.getPercentage(i)
      if (this.toWhat === 'toLess' && percentageString === '0%') {
        this.toWhat = 'toSame'
        percentageString = this.getPercentage(i)
      }
      return percentageString
    },
    getPercentage (i) {
      const comparison = this.compare(i)
      return this.formatPercentage(comparison)
    },
    compare (i) {
      let result
      const data = this.slideData[i].data.freqs
      if (this.toWhat === 'toSame') return data[this.userFreq]
      else {
        this.adverb = 'more'
        result = d3.sum(data.slice(0, this.userFreq))
        if (result <= 0.5) {
          const newResult = d3.sum(data.slice(this.userFreq + 1, data.length))
          if (newResult > result) {
            result = newResult
            this.adverb = 'less'
          }
        }
      }
      return result
    },
    formatPercentage: d3.format('.0%'),
    getPartnerString (i) { return ['didn’t have', 'had'][i] },
    backButtonPress () { this.$emit('backButtonPress') },
    forwardButtonPress () { this.$emit('forwardButtonPress') }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
#slate-int-calculator-chart-header {
  content: "";
  display: table;
  clear: both;
  width: 100%;
}
.sentence-slider {
  width: 100%;
  height: 5em;
  margin-bottom: 0.5em;
  overflow: hidden;
  position: relative;
  text-align: center;
}
.sentence {
  position: absolute;
  font-size: 1.2em;
  top: 0;
  left: 0;
  bottom: 0;
  right:0;
}
.buttons {
  width: 100%;
  height: 2em;
}
.button {
  font-size: 0.8em;
  cursor: pointer;
  position: relative;
}
.button:active {
  top: 1px;
}
.button-container {
  width: 35%;
}
.previous {
  text-align: left;
  float: left;
}
.previous .arrow {
  padding-right: 0.5em;
}
.next {
  text-align: right;
  float: right;
}
.next .arrow {
  padding-left: 0.5em;
}
.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.forward .slide-enter, .back .slide-leave-to {
  transform: translate(100%, 0);
}
.forward .slide-leave-to, .back .slide-enter {
  transform: translate(-100%, 0);
}
@media only screen and (max-width: 583px) {
  .sentence-slider {
    height: 7em;
  } 
}
</style>



// WEBPACK FOOTER //
// ChartHeader.vue?6957af16